<template>
  <svg xml:space="preserve" :x="x" :y="y" :width="width" :height="height" class="siesta-svg" @click="missedItem"><image overflow="visible" width="653" height="355" ref="image"></image><ellipse id="item_2_" fill="#FBAF41" fill-opacity="0.3" stroke="#FFFFFF" stroke-miterlimit="10" cx="556" cy="325.2" rx="94" ry="27.7" @click="foundItem(3, $event)" v-bind:class="{discovered: isFound(3), hinted: isHinted(3)}"></ellipse><ellipse id="item_1_" fill="#FBAF41" fill-opacity="0.3" stroke="#FFFFFF" stroke-miterlimit="10" cx="299.2" cy="222.2" rx="21.9" ry="33" @click="foundItem(4, $event)" v-bind:class="{discovered: isFound(4), hinted: isHinted(4)}"></ellipse><circle id="item_3_" fill="#FBAF41" fill-opacity="0.3" stroke="#FFFFFF" stroke-miterlimit="10" cx="199.2" cy="294.5" r="21.5" @click="foundItem(0, $event)" v-bind:class="{discovered: isFound(0), hinted: isHinted(0)}"></circle><circle id="item_8_" fill="#FBAF41" fill-opacity="0.3" stroke="#FFFFFF" stroke-miterlimit="10" cx="489.8" cy="262.5" r="33" @click="foundItem(1, $event)" v-bind:class="{discovered: isFound(1), hinted: isHinted(1)}"></circle><circle id="item" fill="#FBAF41" fill-opacity="0.3" stroke="#FFFFFF" stroke-miterlimit="10" cx="220.5" cy="234.6" r="33" @click="foundItem(2, $event)" v-bind:class="{discovered: isFound(2), hinted: isHinted(2)}"></circle><foreignObject x="0" y="0" v-if="!hasLoaded" :width="width" :height="height"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></foreignObject></svg>
</template>

<script>
export default {
  data() {
    return {
      hasLoaded: false
    }
  },
  methods: {
    foundItem(id, e) {
      e.stopPropagation();
      if (!this.isFound(id) && !this.isHinted(id)) {
        this.$emit("foundItem", id);
      }
    },
    missedItem() {
      this.$emit("missedItem");
    },
    isFound(id) {
      return this.foundItems.includes(id);
    },
    isHinted(id) {
      return this.foundItemsHints.includes(id);
    },
  },
  props: {
    x: Number,
    y: Number,
    width: Number,
    height: Number,
    isLeft: Boolean,
    image: String,
    foundItems: Array,
    foundItemsHints: Array,
  },
  mounted() {
    this.$options.image = new Image();
    this.$options.image.onload = () => {
      this.hasLoaded = true;
      this.$refs.image.href.baseVal = this.image;
      this.$store.state.game.setLoadedImage(this.isLeft);
    }
    this.$options.image.src = this.image;
  },
  beforeDestroy() {
    this.$options.image.onload = null;
  }
};
</script>

<style lang="scss">
</style>

